import { BrowserRouter, Routes, Route } from 'react-router-dom';
import BookingCreateFlow from './flows/booking-create-flow';
import BookingEditCancelFlow from './flows/booking-edit-cancel-flow';
import BookingConsole from './pages/booking-console';
import BookingConsoleSearchFlow from './flows/booking-console-search-flow';
import BookingConsoleCreateFlow from './flows/booking-console-create-flow';
import BookingConsoleEditFlow from './flows/booking-console-edit-flow';
import Faq from './pages/faq';

const App = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/repair_faq/" element={<Faq />} />
                <Route path="/bookings/new/">
                    <Route index element={<BookingCreateFlow />} />
                    <Route path=":index/" element={<BookingCreateFlow />} />
                </Route>
                <Route path="/bookings/:token/">
                    <Route index element={<BookingEditCancelFlow />} />
                    <Route path=":action/" element={<BookingEditCancelFlow />} />
                    <Route path=":action/:index/" element={<BookingEditCancelFlow />} />
                </Route>
                <Route path="/console/bookings/">
                    <Route index element={<BookingConsole />} />
                    <Route path="search/" element={<BookingConsoleSearchFlow />} />
                </Route>
                <Route path="/console/bookings/new/">
                    <Route index element={<BookingConsoleCreateFlow />} />
                    <Route path=":index/" element={<BookingConsoleCreateFlow />} />
                </Route>
                <Route path="/console/bookings/:token/">
                    <Route index element={<BookingConsoleEditFlow />} />
                    <Route path=":action/" element={<BookingConsoleEditFlow />} />
                    <Route path=":action/:index/" element={<BookingConsoleEditFlow />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default App;
